import kaplay from "kaplay";
import { ASSET_ROOT } from "./assets";
import { DEBUG } from "./config";
import { GAME_HEIGHT, GAME_WIDTH, SCENES } from "./constants";
import { PALETTE } from "./theme";
import { registerStartScene } from "./scenes/start";
import { registerGameScene } from "./scenes/game";
import { registerGameOverScene } from "./scenes/gameover";

const gameElement = document.getElementById("game");
if (!gameElement) {
    throw new Error("#game not found");
}

const k = kaplay({
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    letterbox: true,
    root: gameElement,
    background: PALETTE.background,
    debug: DEBUG,
});

k.loadRoot(ASSET_ROOT);

registerStartScene(k);
registerGameScene(k);
registerGameOverScene(k);

k.go(SCENES.start);

if (DEBUG) {
    console.log("[ColourFalls] Engine initialized with asset root:", ASSET_ROOT);
}
